module.exports = __webpack_public_path__ + "static/img/3_11_1.1a1d6925.jpg";